import http from '@/service/http'
import { DriverCenterUrl } from '@/common/url'
import * as T from './types'

export const driverMineApi: T.IDriverMineApi = {
  demo(params) {
    return http.post('/demo', params)
  },
  uploadFleetPortrait(params) {
    return http.upload(DriverCenterUrl.UploadFleetPortrait, params)
  },
  getPortraitPermission() {
    return http.get(DriverCenterUrl.GetPortraitPermission)
  },
  getCarList(params) {
    return http.get(DriverCenterUrl.CarList, params)
  },
  getCarTypeTotal(params) {
    return http.get(DriverCenterUrl.CarCount, params)
  },
  uploadSignPicture(params) {
    return http.upload(DriverCenterUrl.UploadVehiclePicture, params)
  },
  putVehicleOnSelf(params) {
    return http.post(DriverCenterUrl.PutVehicleOnSelf, params)
  },
  getVehicleDetail(params) {
    return http.get(DriverCenterUrl.VehicleDetail, params)
  },
  rentConfig(params) {
    return http.get(DriverCenterUrl.RentConfig, params)
  },
  getFundMode(params) {
    return http.get(DriverCenterUrl.FundMode, params)
  },
  changeFundMode(params) {
    return http.post(DriverCenterUrl.FundModeModify, params, {
      'Content-Type': 'application/json'
    })
  },
  getMaxSettingAmount(params) {
    return http.get(DriverCenterUrl.MaxSettingAmount, params)
  },
  checkDriverEdited(params) {
    return http.get(DriverCenterUrl.CheckDriverEdited, params)
  },
  getRecommendFleetInfo(params) {
    return http.get(DriverCenterUrl.RecommendFleetInfo, params)
  },
  saveRecommendFleetInfo(params) {
    return http.post(DriverCenterUrl.SaveRecommendFleetInfo, params)
  },
  getOpenCityList(params) {
    return http.get(DriverCenterUrl.OpenCityList, params)
  },
  putCarOffShelf(params) {
    return http.post(DriverCenterUrl.PutCarOffShelf, params)
  },
  getRecomDriverList(params) {
    return http.get(DriverCenterUrl.RecomDriverList, params)
  },
  getCenterDriverDetail(params) {
    return http.get(DriverCenterUrl.CenterDriverDetail, params)
  },
  getCenterDriverMapUrl(params) {
    return http.get(DriverCenterUrl.CenterDriverMapUrl, params)
  },
  getRecommendDriverResume(params) {
    return http.get(DriverCenterUrl.RecommendDriverResume, params)
  },
  markDriver(params) {
    return http.post(DriverCenterUrl.MarkDriver, params)
  },
  getVirtualPhone(params) {
    return http.get(DriverCenterUrl.VirtualPhone, params)
  },
  getVehicleStatus(params) {
    return http.get(DriverCenterUrl.VehicleStatus, params)
  },

  getPickAddressList(params) {
    return http.get(DriverCenterUrl.PickAddressList, params)
  },
  searchPickAddress(params) {
    return http.get(DriverCenterUrl.SearchPickAddress, params)
  },
  getPickAddressDetail(params) {
    return http.get(DriverCenterUrl.PickAddressDetail, params)
  },
  getReverseAddress(params) {
    return http.get(DriverCenterUrl.ReverseAddress, params)
  },
  savePickAddress(params) {
    return http.post(DriverCenterUrl.SavePickAddress, params)
  },
  deletePickAddress(params) {
    return http.post(DriverCenterUrl.DeletePickAddress, params)
  },
}